import { render, staticRenderFns } from "./BudgetList.vue?vue&type=template&id=14152bc4&scoped=true"
import script from "./BudgetList.vue?vue&type=script&lang=js"
export * from "./BudgetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14152bc4",
  null
  
)

export default component.exports